import { ModuleConfig, ModuleFields } from "~/Utils/drilldownData";

export const getTrainingAcademyDrillDownData: { [key in ModuleConfig]: ModuleFields[] } = {
  introduction: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_introduction_text",
      className: "col-span-6",
      type: "text",
      name: "field_introduction_text",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_introduction_text_ms",
        className: "col-span-6",
        type: "text",
        name: "field_introduction_text_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_introduction_text_zhans",
        className: "col-span-6",
        type: "text",
        name: "field_introduction_text_zhans",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_inrto_description",
      className: "col-span-6",
      type: "text",
      name: "field_inrto_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_inrto_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_inrto_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_inrto_description_zhans",
      className: "col-span-6",
      type: "text",
      name: "field_inrto_description_zhans",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "intro_image",
      className: "col-span-6",
      type: "image",
      name: "intro_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Replace Image",
      validation: { required: "Image URL is required" },
    },
  ],
  trainingFacilities: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_heading",
      className: "col-span-6",
      type: "text",
      name: "field_heading",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_heading_ms",
        className: "col-span-6",
        type: "text",
        name: "field_heading_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_heading_zhans",
        className: "col-span-6",
        type: "text",
        name: "field_heading_zhans",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    // {
    //   fieldName: "Icon Image",
    //   fieldValue: "icon",
    //   className: "col-span-6",
    //   type: "image",
    //   name: "icon",
    //   formType: "file",
    //   usedFileType: 'image/*',
    //   label: "Icon Image",
    //   placeholder: "Replace Icon Image",
    //   validation: { required: "Icon Image is required" },
    // },
    {
      fieldName: "Images",
      fieldValue: "field_img",
      className: "col-span-6",
      type: "image",
      name: "field_img",
      formType: "multiFile",
      usedFileType: 'image/*',
      label: "Images",
      placeholder: "Replace Images",
      validation: { required: "Images are required" },
    },
    // {
    //   fieldName: "Published",
    //   fieldValue: "published",
    //   className: "col-span-12",
    //   type: "checkbox",
    //   name: "published",
    //   formType: "checkbox",
    //   label: "Published",
    //   placeholder: "Enter Published",
    //   // validation: { required: "Publish is required" },
    // }
  ],
  accreditationAndCertifications: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_certifications_title",
      className: "col-span-6",
      type: "text",
      name: "field_certifications_title",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_certifications_title_ms",
        className: "col-span-6",
        type: "text",
        name: "field_certifications_title_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_certifications_title_zhans",
        className: "col-span-6",
        type: "text",
        name: "field_certifications_title_zhans",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_desc",
      className: "col-span-6",
      type: "text",
      name: "field_desc",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_desc_ms",
      className: "col-span-6",
      type: "text",
      name: "field_desc_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_desc_zhans",
      className: "col-span-6",
      type: "text",
      name: "field_desc_zhans",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Icon Images",
      fieldValue: "field_images",
      className: "col-span-6",
      type: "image",
      name: "field_images",
      formType: "multiFile",
      usedFileType: 'image/*',
      label: "Icon Images",
      placeholder: "Replace Icon Images",
      validation: { required: "Icon Images are required" },
    },
    // {
    //   fieldName: "Video Link 1",
    //   fieldValue: "video_link_1",
    //   className: "col-span-6",
    //   type: "video",
    //   name: "video_link_1",
    //   formType: "file",
    //   usedFileType: 'video/*',
    //   label: "Video Link 1",
    //   placeholder: "Replace Video Link 1",
    //   validation: { required: "Video Link 1 is required" },
    // },
    // {
    //   fieldName: "Video Link 2",
    //   fieldValue: "video_link_2",
    //   className: "col-span-6",
    //   type: "video",
    //   name: "video_link_2",
    //   formType: "file",
    //   usedFileType: 'video/*',
    //   label: "Video Link 2",
    //   placeholder: "Replace Video Link 2",
    //   validation: { required: "Video Link 2 is required" },
    // },
  ],
  videoSection: [
    {
      fieldName: "Video Link 1",
      fieldValue: "video_link_1",
      className: "col-span-6",
      type: "video",
      name: "video_link_1",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video Link 1",
      placeholder: "Replace Video Link 1",
      validation: { required: "Video Link 1 is required" },
    },
    {
      fieldName: "Video Link 2",
      fieldValue: "video_link_2",
      className: "col-span-6",
      type: "video",
      name: "video_link_2",
      formType: "file",
      usedFileType: 'video/*',
      label: "Video Link 2",
      placeholder: "Replace Video Link 2",
      validation: { required: "Video Link 2 is required" },
    },
  ],
  latestNewsList: [
    {
      fieldName: "Title (EN)",
      fieldValue: "field_header",
      className: "col-span-6",
      type: "text",
      name: "field_header",
      formType: "input",
      label: "Title (EN)",
      placeholder: "Enter Title (EN)",
      validation: { required: "Title (EN) is required" },
    },
    {
        fieldName: "Title (MS)",
        fieldValue: "field_header_ms",
        className: "col-span-6",
        type: "text",
        name: "field_header_ms",
        formType: "input",
        label: "Title (MS)",
        placeholder: "Enter Title (MS)",
        // validation: { required: "Title (MS) is required" },
    },
    {
        fieldName: "Title (ZH)",
        fieldValue: "field_header_zhans",
        className: "col-span-6",
        type: "text",
        name: "field_header_zhans",
        formType: "input",
        label: "Title (ZH)",
        placeholder: "Enter Title (ZH)",
        // validation: { required: "Title (ZH) is required" },
    },
    {
        fieldName: "Date",
        fieldValue: "field_latest_news_date",
        className: "col-span-6",
        type: "dateTime",
        name: "field_latest_news_date",
        formType: "dateTime",
        label: "Date",
        placeholder: "Enter Date",
        validation: { required: "Date is required" },
    },
    {
      fieldName: "Description (EN)",
      fieldValue: "field_description",
      className: "col-span-6",
      type: "text",
      name: "field_description",
      formType: "richText",
      label: "Description (EN)",
      placeholder: "Enter Description (EN)",
      validation: { required: "Description (EN) is required" },
    },
    {
      fieldName: "Description (MS)",
      fieldValue: "field_description_ms",
      className: "col-span-6",
      type: "text",
      name: "field_description_ms",
      formType: "richText",
      label: "Description (MS)",
      placeholder: "Enter Description (MS)",
      // validation: { required: "Description (MS) is required" },
    },
    {
      fieldName: "Description (ZH)",
      fieldValue: "field_description_zhans",
      className: "col-span-6",
      type: "text",
      name: "field_description_zhans",
      formType: "richText",
      label: "Description (ZH)",
      placeholder: "Enter Description (ZH)",
      // validation: { required: "Description (ZH) is required" },
    },
    {
      fieldName: "Image",
      fieldValue: "field_img",
      className: "col-span-6",
      type: "image",
      name: "field_img",
      formType: "file",
      usedFileType: 'image/*',
      label: "Image",
      placeholder: "Select Image",
      validation: { required: "Image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
  trainingAcademyBanner: [
    {
      fieldName: "Order Sequence",
      fieldValue: "order_sequence",
      className: "col-span-6",
      type: "text",
      name: "order_sequence",
      formType: "number",
      label: "Order Sequence",
      placeholder: "Enter Order Sequence",
      validation: { required: "Order Sequence is required" },
    },
    {
      fieldName: "Banner Image",
      fieldValue: "field_banner_image",
      className: "col-span-6",
      type: "image",
      name: "field_banner_image",
      formType: "file",
      usedFileType: 'image/*',
      label: "Banner Image",
      placeholder: "Select Banner Image",
      validation: { required: "Banner Image is required" },
    },
    {
      fieldName: "Published",
      fieldValue: "published",
      className: "col-span-12",
      type: "checkbox",
      name: "published",
      formType: "checkbox",
      label: "Published",
      placeholder: "Enter Published",
      // validation: { required: "Publish is required" },
    }
  ],
};
